import { isPostPublishInFlight } from '../../utils/postPublishErrors';

/** Shared status → chip appearance map (Phase 7.2). */
export const STATUS_PRESETS = {
  published: { label: 'Published', color: 'success', variant: 'filled' },
  failed: { label: 'Failed', color: 'error', variant: 'filled' },
  publishing: { label: 'Publishing…', color: 'info', variant: 'outlined' },
  queued: { label: 'Queued', color: 'warning', variant: 'outlined' },
  scheduled: { label: 'Scheduled', color: 'warning', variant: 'outlined' },
  draft: { label: 'Draft', color: 'default', variant: 'outlined' },
  pending_sync: { label: 'Pending sync', color: 'warning', variant: 'outlined' },
  active: { label: 'Active', color: 'success', variant: 'filled' },
  inactive: { label: 'Inactive', color: 'default', variant: 'outlined' },
  archived: { label: 'Archived', color: 'default', variant: 'outlined' },
};

export function getPublishStatusPreset(post) {
  const publishStatus = (post?.publish_status || '').toLowerCase();
  const status = (post?.status || '').toLowerCase();

  if (status === 'failed' || publishStatus === 'failed') {
    return STATUS_PRESETS.failed;
  }
  if (status === 'published' || publishStatus === 'published') {
    return STATUS_PRESETS.published;
  }
  if (isPostPublishInFlight(post)) {
    return STATUS_PRESETS.publishing;
  }
  if (publishStatus === 'queued' || status === 'scheduled') {
    return STATUS_PRESETS.queued;
  }
  if (status === 'draft') {
    return STATUS_PRESETS.draft;
  }

  return {
    label: publishStatus || status || 'Unknown',
    color: 'default',
    variant: 'outlined',
  };
}
